import { FormGeneratorProps, FormField, FormFieldContainer } from "./types";
import { Grid } from "@mui/material";
import React from "react";
import { useAbac } from "utils/abac";
import { RenderFormField } from "./components";
import { toGridItemProps } from "./grid-props";

const isFormFieldContainer = (field: FormField | FormFieldContainer): field is FormFieldContainer => {
  return typeof field === "object" && "fields" in field;
};

const FormFields: React.FC<FormGeneratorProps> = ({ rule, fields, containerGridProps = {}, children = null }) => {
  const { userHasPermissions } = useAbac();
  const hasAddPermission = typeof rule === "string" ? userHasPermissions(rule) : rule;

  return (
    <Grid container spacing={containerGridProps.spacing || 4} {...containerGridProps}>
      {fields.map((field, index) => {
        const fieldIsFormFieldContainer = isFormFieldContainer(field);

        /* 
          You can either render a FormField or a new container with multiple FormFields 
            This allows us to do custom grid styling such as multiple fields next to a single field
              |field| | field |
              |field| | field |
              |field|  /     \
              |field| | field |
              |field|  \     /
        */
        if (fieldIsFormFieldContainer) {
          if (field.hide) return null;
          return (
            <Grid key={`form-fields-container-${index}`} {...toGridItemProps(field.gridProps)}>
              <Grid container spacing={field.containerGridProps?.spacing || 4} {...(field.containerGridProps || {})}>
                {(field as FormFieldContainer).fields.map((formContainerField, i) => (
                  <RenderFormField field={formContainerField} hasAddPermission={hasAddPermission} keyIndex={i} key={`rendered-form-container-${index}-form-field-${i}`} />
                ))}
              </Grid>
            </Grid>
          );
        }

        return <RenderFormField field={field} hasAddPermission={hasAddPermission} keyIndex={index} key={`rendered-form-field-${index}`} />;
      })}
      {children}
    </Grid>
  );
};

export default FormFields;
